import { LanguageValues } from 'common/types/instance'

export const SUPPORTED_LOCALES = [LanguageValues.En, LanguageValues.Es, LanguageValues.Pt]
export const DEFAULT_LOCALE = LanguageValues.En

export const isSupportedLocale = (locale?: string | null): locale is LanguageValues =>
  !!locale && SUPPORTED_LOCALES.includes(locale as LanguageValues)

export const getBrowserLocale = (): LanguageValues => {
  const browserLanguage = navigator.language?.substring(0, 2).toLowerCase() ?? ''
  return (
    SUPPORTED_LOCALES.find((locale) => locale.toLowerCase().startsWith(browserLanguage)) ??
    DEFAULT_LOCALE
  )
}

/* The stored language preference can hold values outside LanguageValues: it falls back to the
 * company preference, whose JSON is saved without validating the value. An unsupported one used
 * to leave IntlProvider without a message bundle, rendering raw message ids. */
export const resolveAppLocale = (
  ...preferredLocales: (string | null | undefined)[]
): LanguageValues => preferredLocales.find(isSupportedLocale) ?? getBrowserLocale()
